<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >

<!-- ADDRESS -->
   <vs-tab
      icon-pack="feather"
      icon="icon-map-pin"
      :label="!isSmallerScreen ? 'Adresse' : ''"
    >
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <profile-addresses />
      </div>
    </vs-tab>

    <!-- PROFILE -->
    <vs-tab
      icon-pack="feather"
      icon="icon-user"
      :label="!isSmallerScreen ? 'Dein Profil' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <profile-general />
      </div>
    </vs-tab>

     <!-- CHANGE PASSWORD -->
    <vs-tab
      icon-pack="feather"
      icon="icon-lock"
      :label="!isSmallerScreen ? 'Passwort ändern' : ''"
    >
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <profile-change-password />
      </div>
    </vs-tab>

  </vs-tabs>
</template>

<script>
import ProfileGeneral from "./ProfileGeneral.vue";
import ProfileChangePassword from "./ProfileChangePassword.vue";
import ProfileAddresses from "./ProfileAddresses.vue";

export default {
  components: {
    ProfileGeneral,
    ProfileChangePassword,
    ProfileAddresses,
  },
  data() {
    return {};
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
